import React, { useEffect } from "react";
import { useSelector, Provider, useDispatch } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { selectedLocale, setSelectedLocale } from "./store/slices/common/slice";
import { FRONT_URL, injectStore } from "./api/index";
import { SESSION_STORAGE_SELECTED_LOCALE } from "./utils/constants";
// import { Chart, ArcElement } from "chart.js";

import reportWebVitals from "./reportWebVitals";
import i18next from "i18next";
import App from "./App";
import store from "./store";

import "react-phone-input-2/lib/material.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/index.css";
import "./styles/responsive.css";
import "./i18n/I18n";

injectStore(store);
// Chart.register(ArcElement);

const AppWithRouter = () => {
  const locale = useSelector(selectedLocale);
  const { pathname, search } = window.location;
  const dispatch = useDispatch();

  const fullPath = window.location.href;
  let languageInPath = fullPath?.split(FRONT_URL)[1]?.split("/")[1];

  if (!["en", "ar"].includes(languageInPath)) {
    languageInPath = null;
  }

  const language = languageInPath ? languageInPath : locale ?? "ar";

  useEffect(() => {
    if (!pathname.startsWith(`/${language}`)) {
      const newPath = search
        ? `/${language}${pathname
            .replaceAll("/ar", "")
            .replaceAll("/en", "")}${search}`
        : `/${language}${pathname.replaceAll("/ar", "").replaceAll("/en", "")}`;

      window.history.replaceState({}, "", newPath);
      window.location.reload();
    }
    if (language !== locale) {
      localStorage.setItem(SESSION_STORAGE_SELECTED_LOCALE, language);
      dispatch(setSelectedLocale(language));
      i18next.changeLanguage(language);
    }
  }, []);

  return (
    <Router basename={`/${language}`}>
      <App />
    </Router>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <AppWithRouter />
  </Provider>
);

reportWebVitals();
